import { createPinia } from "pinia";
export const instance = createPinia();
